import { ImageContentCardData } from "types/image-content-card-data";
import { ActivityFilter } from "types/filters";
import { getActivitiesForFilters } from "hooks/get-filtered-activities";
import { isGatsbyImageData } from "helpers/is-gatsby-image";
import { getLinkById } from "hooks/use-generate-site-link";

// Import Luxon
import { DateTime } from "luxon";

export const getImageContentCardsForActivities = (
    linkLabel: string,
    ActivityFilters: ActivityFilter[],
    signatureEventId?: string
): ImageContentCardData[] => {
    const activities = getActivitiesForFilters(
        ActivityFilters,
        signatureEventId
    );

    if (activities.length > 0) {
        return activities.map((activity) => {
            const image = isGatsbyImageData(
                activity.heroImage?.carouselCardGatsbyImage
            )
                ? activity.heroImage?.carouselCardGatsbyImage
                : undefined;

            const buttonUrl = getLinkById(activity.id, signatureEventId) ?? "#";

            const activitySignatureEventDetails =
                activity.signatureEventDetails?.find(
                    (detail) => detail?.signatureEvent?.id === signatureEventId
                );

            // get all the dates from the signature event details and filter out null and undefined values
            const dates =
                activitySignatureEventDetails?.schedule?.hoursForDates
                    ?.map((hours) => hours?.date)
                    .filter(
                        (date): date is string =>
                            date !== null && date !== undefined
                    ) ?? [];

            // sort the dates and get the first date
            const firstDate =
                dates.length > 0
                    ? DateTime.fromISO(dates.sort()[0], { zone: 'America/Los_Angeles' })
                    : undefined;

            return {
                id: activity.id,
                cardImage: image,
                cardImageAlt: activity.heroImage?.alt ?? "",
                headline: activity.title ?? "",
                date: firstDate,
                subtext: activity.shortDescription ?? "",
                buttonText: linkLabel,
                buttonUrl: buttonUrl,
            };
        });
    }

    return [];
};
